import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_REFERENCE,
  SAVE_REFERENCE_SUCCESS,
  SAVE_REFERENCE_FAILURE,
  ADD_REFERENCE_TO_THE_LIST,
  UPDATE_REFERENCE_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-REFERENCE--->>>
export const saveReferenceInProgress = createAction(SAVE_REFERENCE);
export const saveReferenceSuccess = createAction(SAVE_REFERENCE_SUCCESS);
export const addReferenceToTheList = createAction(ADD_REFERENCE_TO_THE_LIST);
export const saveReferenceFailure = createAction(SAVE_REFERENCE_FAILURE);

export const saveReference = (formData, lang, callback) => async dispatch => {
  dispatch(saveReferenceInProgress());
  try {
    const res = await api.post(`reference/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(saveReferenceSuccess(data));
    dispatch(addReferenceToTheList(data));
  } catch (error) {
    dispatch(saveReferenceFailure(error));
  }
};

//<<<---UPDATE-REFERENCE--->>>
export const updateReferenceInTheList = createAction(
  UPDATE_REFERENCE_IN_THE_LIST
);

export const updateReference = (
  formData,
  id,
  lang,
  callback
) => async dispatch => {
  dispatch(saveReferenceInProgress());
  try {
    const res = await api.post(`reference/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(saveReferenceSuccess(data));
    dispatch(updateReferenceInTheList(data));
  } catch (error) {
    dispatch(saveReferenceFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () =>
  change(formName, fieldName, {});



// WEBPACK FOOTER //
// ./src/modules/ReferenceForm/actions.js